"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const API = {
    updateDisplay: (serviceId) => `/blockpass_console/v1/services/${serviceId}`,
    updateLiveStatus: (serviceId) => `/blockpass_console/v1/services/${serviceId}/live`,
};
class ServiceManagementAPI {
    constructor(httpClient, config) {
        this._httpClient = httpClient;
        this._baseURL = config.baseURL;
    }
    async updateDisplayInfo(serviceId, updateParam) {
        const data = {
            result: null,
            entities: {},
        };
        const res = await this._httpClient.put(API.updateDisplay(serviceId), updateParam, {
            baseURL: this._baseURL,
        });
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody._id;
        data.entities = {
            services: {
                [resBody._id]: lodash_1.default.pick(resBody, [
                    '_id',
                    'name',
                    'short_description',
                    'long_description',
                    'logo',
                    'thumbnail',
                    'website',
                    'license_url',
                    'support_email',
                    'support_portal',
                    'terms_and_conditions_url',
                    'privacy_policy_url',
                    'shareable_link',
                    'shareable_method',
                    'status',
                    'isLive',
                    'client_id',
                ]),
            },
        };
        return data;
    }
    async updateLiveStatus(serviceId, isLive) {
        await this._httpClient.put(API.updateLiveStatus(serviceId), { isLive }, { baseURL: this._baseURL });
        return {
            result: null,
            entities: {},
        };
    }
}
exports.default = ServiceManagementAPI;
